import App from "./product-configurator-simple.svelte";
import { createComponentMounter } from "../../utils/component-mounter";


const mounter = createComponentMounter({
	component: App,
	selector: ".wpc-product-configurator",
	getPropsFromElement: (element: HTMLElement) => {
		// Extract data attributes
		const productId = element.dataset.productId
			? Number.parseInt(element.dataset.productId, 10)
			: 0;
		const apiUrl = element.dataset.apiUrl || "";
		const isAdmin = element.dataset.isAdmin === "true";
		const debugEnabled = element.dataset.debugEnabled === "true";

		return {
			productId,
			apiUrl,
			isAdmin,
			debugEnabled,
		};
	},
});

export default mounter.getMountedApps();
